const landAdvisorModes = {
  VIEW: 'view',
  DRAW: 'draw',
  ANALYSIS: 'analysis',
} as const;

export default landAdvisorModes;
